module.exports = __webpack_public_path__ + "img/house.7f05e4ca.svg";